// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { closedOrdersStyles } from "@gcg/App/Widgets/OrderHistory/ClosedOrders";
import { screen } from "@gcg/XDL/Helpers";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

closedOrdersStyles.container = {
    css: css`
        overflow: auto;
    `,
};
closedOrdersStyles.spinner = {
    color: "primary.main",
    css: css`
        margin: auto;
    `,
};
closedOrdersStyles.reorderButton = {
    variant: "primary",
    sizeVariant: "small",
    css: css`
        display: flex;
        align-items: center;
        width: 48px;
        height: 40px;
        min-height: 40px;
        justify-content: center;
        padding: 0;

        svg {
            color: ${getColor("common.white")};
        }
    `,
};
closedOrdersStyles.reorderButtonSpinner = {
    color: "primary.main",
    size: 22,
    css: css`
        margin-left: auto;
        margin-right: auto;
        display: block;
    `,
};
closedOrdersStyles.shipToHeader = {
    tight: true,
};
closedOrdersStyles.orderTotalHeader = {
    tight: true,
    alignX: "left",
};
closedOrdersStyles.reorderHeader = {
    tight: true,
};
closedOrdersStyles.orderTotalCells = {
    alignX: "left",
};
closedOrdersStyles.statusCells = {
    alignX: "left",
};
closedOrdersStyles.shipToCells = {
    typographyProps: {
        ellipsis: true,
        css: css`
            display: block;
            max-width: 146px;

            ${screen("gt", "lg")`
                max-width: 224px;
            `}
        `,
    },
};
closedOrdersStyles.trackingNumber = {
    css: css`
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
        max-width: 146px;
    `,
};
closedOrdersStyles.headerContainer = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: baseline;

        ${screen("lt", "sm")`
            display: block;
        `}
    `,
};
closedOrdersStyles.viewAllLink = {
    css: css`

        ${screen("lt", "sm")`
            display: flex;
            justify-content: flex-end;
        `}
    `,
};
